import { render, staticRenderFns } from "./dateClosingFlatPickr.vue?vue&type=template&id=b53a16a8&"
import script from "./dateClosingFlatPickr.vue?vue&type=script&lang=js&"
export * from "./dateClosingFlatPickr.vue?vue&type=script&lang=js&"
import style0 from "./dateClosingFlatPickr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports